import { useState } from 'react';

import { IfFeatureState_Core } from 'core';
import { EditAccountCodeModal } from 'core/Components';
import { Outlet, Route, Routes } from 'react-router-dom';
import { ButtonMantine, Group } from 'ui';

import { useCrowdfundingProvider } from '../../../../Context';
import { useShowDonationStoreItem } from '../../../../api/CrowdFunding/Management/donations/donations';
import { useStoreAccountCodes } from '../../../../hooks/useStoreAccountCodes';
import { useCampaignModalLayoutContext } from '../../../routes/management/campaignModalLayout';
import { Editor } from '../components/Editor/CampaignEditor';
import { NavLinks, navLinkCreator } from '../components/Editor/NavLinks/NavLinks';
import { GeneralDonationSettings } from './GeneralDonationSettings';

const SettingsHeader = ({ causeId }: { causeId: string }) => {
  const [isAssignAccountCodeModalOpen, setIsAssignAccountCodeModalOpen] = useState(false);

  const { accountCodeActionLabel, hasWriteAccess } = useStoreAccountCodes({
    causeId: causeId,
    feature: 'donation',
  });

  const { data: donationStoreItem } = useShowDonationStoreItem({ causeId });

  return (
    <>
      <Editor.Header title="Edit Direct Donation Settings">
        <Group gap={'xs'}>
          <IfFeatureState_Core featureId="accountCodes">
            <ButtonMantine
              size="md"
              variant="subtle"
              onClick={() => setIsAssignAccountCodeModalOpen(true)}
            >
              {accountCodeActionLabel}
            </ButtonMantine>
          </IfFeatureState_Core>
        </Group>
      </Editor.Header>
      <EditAccountCodeModal
        accountCode={donationStoreItem?.account_code}
        causeId={causeId}
        storeItemId={donationStoreItem?.uuid}
        opened={isAssignAccountCodeModalOpen}
        onClose={() => setIsAssignAccountCodeModalOpen(false)}
        feature="donation"
        hasWriteAccess={hasWriteAccess}
      />
    </>
  );
};

const donationSettingsRoutes = navLinkCreator({
  label: 'Payment Settings',
  path: 'settings',
});

// const howToShareLink = navLinkCreator({
//   label: 'How To Share',
//   path: 'share',
// });

const Setting = () => {
  const { setIsCloseable, setCloseButtonRef } = useCampaignModalLayoutContext();
  const { isLoading } = useShowDonationStoreItem();
  const { causeId } = useCrowdfundingProvider();

  if (!causeId) return null;
  return (
    <Editor
      onDirty={(isDirty) => {
        setIsCloseable?.(!isDirty);
      }}
      setWarningRef={setCloseButtonRef}
      header={<SettingsHeader causeId={causeId} />}
      navbar={
        <Editor.Navbar>
          <NavLinks routes={[donationSettingsRoutes]} />
        </Editor.Navbar>
      }
      isLoading={isLoading}
    >
      {!isLoading && <Outlet />}
    </Editor>
  );
};

const Settings = () => {
  return <GeneralDonationSettings />;
};

const Donations = () => {
  return (
    <Routes>
      <Route element={<Setting />}>
        <Route index element={<Settings />} />
      </Route>
    </Routes>
  );
};

export { Donations };
